import script from "./HeaderChatMessagesPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderChatMessagesPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderChatMessagesPanel.vue?vue&type=style&index=0&id=6a80ad7e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a80ad7e"]])

export default __exports__